import { Store } from 'stores/type';
import { Element } from 'types';

const EXHAUSTED_LIBRARY_DURATION = 1.05 * 1000;

class AnimationManager {
  private $store!: Store;

  public init(store: Store) {
    this.$store = store;
  }

  public startExhausted(id: Element['id']) {
    this.$store.dispatch('animationExhaustedStart', id);
    window.setTimeout(() => {
      this.$store.dispatch('animationExhaustedFinished', id);
      this.$store.dispatch('animationReset');
    }, EXHAUSTED_LIBRARY_DURATION);

    this.startFinal(id);
  }

  public startFinal(id: Element['id']) {
    this.$store.dispatch('animationFinalStart', id);
  }
}

export default new AnimationManager();
